import * as React from "react";
const SvgMinusIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.51477 12H20.4853", stroke: "#4A4A4A", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMinusIcon;
